"use client";

import { withFallback } from "../with-fallback";

export const WithdrawalBreakdownElement = withFallback<
	"withdrawal-breakdown-element",
	true
>({
	displayName: "WithdrawalBreakdownElement",
	type: "withdrawal-breakdown-element",
});
